import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {Chart} from 'chart.js';
  import {Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {DoctorService} from '../../../../services/doctor.service';
  import {MatDialog} from '@angular/material/dialog';
  import {Observable, Subscription} from 'rxjs';
  import {MatTableDataSource} from '@angular/material/table';
  import {Patient} from '../../../../model/user/Patient';
  import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
  import {MatCheckboxChange} from '@angular/material/checkbox';
  import {MatSnackBar} from "@angular/material/snack-bar";
  
@Component({
  selector: 'app-bar-chart-inactive-pathology',
  templateUrl: './bar-chart-inactive-pathology.component.html',
  styleUrls: ['./bar-chart-inactive-pathology.component.css']
})
export class BarChartInactivePathologyComponent implements OnInit {

        // per inizializzazione
        getAuthState: Observable<any>;
        getDoctorState: Observable<any>;
        isAuthenticated: boolean;
        user = null;
        errorMessage = null;
        subscription1: Subscription;
        subscription2: Subscription;
        subscription3: Subscription;
        subscription4: Subscription;
        subscription5: Subscription;
        title = "Patologia";
        destination = 'inactive';

        
        // elementi che servono per il bar-chart
        canvas: any;
        ctx: any;
        myChartInactivePatients: Chart;
  
        // ******************************************************************************************************************
        // seguenti righe: inizializzazione dei pazienti 
        // ******************************************************************************************************************
        inactiveGlobalUC = 0;
        inactiveGlobalCD = 0;
        inactiveGlobalAltro = 0;
  
        activeGlobalUC = 0;
        activeGlobalCD = 0;
        activeGlobalAltro = 0;
  
        UCGlobalPatients = 0;
        CDGlobalPatients = 0;
        AltroGlobalPatients = 0;
  
        inactiveGlobalPatientsArray = [];
        activeGlobalPatientsArray = [];
        inactivePatientsGlobal = [];
        // ******************************************************************************************************************
        // bar chart dei pazienti 
        // ******************************************************************************************************************
        public barChartLabelsGlobalInactive = ['MALATTIA DI CROHN', 'COLITE ULCEROSA','ALTRO'];
        public barChartTypeGlobalInactive = 'horizontalBar';
        public barChartLegendGlobalInactive = true;
        public barChartDataGlobalInactive = [
          {
            data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal', 'teal','teal'],
            hoverBackgroundColor: ['#066', '#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
          },
          {
            data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered', 'orangered','orangered'],
            hoverBackgroundColor: ['#cc3700', '#cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
          }];
        
  
  
        // constructor
        constructor(private store: Store<AppState>,
                    private doctorService: DoctorService,
                    private snackBar: MatSnackBar) {
          this.getAuthState = this.store.select(selectAuthState);
          this.getDoctorState = this.store.select(selectDoctorState);
        }
        // ******************************************************************************************************************
        // metodo all'inizio
        ngOnInit(): void {
          this.subscription5 = this.getAuthState.subscribe((state) => {
            this.isAuthenticated = state.isAuthenticated;
            this.user = JSON.parse(localStorage.getItem('user'));
            this.errorMessage = state.errorMessage;
            this.retrieveGlobalInactiveCD();
          });
        }
        ngOnDestroy(): void {
          this.subscription1.unsubscribe();
          this.subscription2.unsubscribe();
          this.subscription3.unsubscribe();
          this.subscription4.unsubscribe();
          this.subscription5.unsubscribe();
        }
        // ******************************************************************************************************************
        // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
        // e in standard e poi tutti
        // i pazienti in ogni categoria per poter calcolare gli attivi
        // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
        retrieveGlobalInactiveCD() {
          this.subscription1 = this.doctorService.getInactiveCDNumber().subscribe(npatients => {
            this.inactiveGlobalCD = parseInt(npatients.toString());
            this.inactiveGlobalPatientsArray.push(this.inactiveGlobalCD); // riempio vettore del bar-chart con telemedicina
            this.retrieveGlobalInactiveUC();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
        retrieveGlobalInactiveUC() {
          this.subscription2 = this.doctorService.getInactiveUCNumber().subscribe(npatients => {
            this.inactiveGlobalUC = parseInt(npatients.toString());
            this.inactiveGlobalPatientsArray.push(this.inactiveGlobalUC); // riempio il vettore del bar chart con standard
            this.retrieveGlobalInactiveAltro();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
  
        retrieveGlobalInactiveAltro() {
          this.subscription3 = this.doctorService.getInactiveAltroNumber().subscribe(npatients => {
            this.inactiveGlobalAltro = parseInt(npatients.toString());
            this.inactiveGlobalPatientsArray.push(this.inactiveGlobalAltro); // riempio il vettore del bar chart con standard    
            this.retrieveGlobalUCCD();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
  
      
        retrieveGlobalUCCD() {
          this.subscription4 = this.doctorService.getGlobalUCCDLoginExistsNumber().subscribe(num => {
            this.UCGlobalPatients = num[0];
            this.CDGlobalPatients = num[1];
            this.AltroGlobalPatients = num[2];
            this.activeGlobalCD = this.CDGlobalPatients - this.inactiveGlobalCD;
            this.activeGlobalPatientsArray.push(this.activeGlobalCD); // riempio il vettore del bar chart con telemedicina
            this.activeGlobalUC = this.UCGlobalPatients - this.inactiveGlobalUC;
            this.activeGlobalPatientsArray.push(this.activeGlobalUC); // riempio il vettore del bar chart con standard
            this.activeGlobalAltro = this.AltroGlobalPatients - this.inactiveGlobalAltro;
            this.activeGlobalPatientsArray.push(this.activeGlobalAltro); // riempio il vettore del bar chart con telemedicina
           
            this.canvasSetting();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
       
        canvasSetting() {
            this.canvas = document.getElementById('myChartInactivePathology') as HTMLCanvasElement;
            this.ctx = this.canvas.getContext('2d');
            this.myChartInactivePatients = new Chart(this.ctx, {
              type: this.barChartTypeGlobalInactive,
              data: {
                labels: this.barChartLabelsGlobalInactive,
                datasets: this.barChartDataGlobalInactive,
              },
              options: {
                maintainAspectRatio: true,
                responsive: true,
  
                scales: {
                  xAxes: [{
                    display: true,
                    stacked: false,
                    ticks: {
                      fontSize: 12,
                      fontStyle: 'bold',
                      fontFamily: 'Helvetica',
                      fontColor: '#006192'
                    }
                  }],
                  yAxes: [{
                    display: true,
                    stacked: false,
                    ticks: {
                      fontSize: 12,
                      fontStyle: 'bold',
                      fontFamily: 'Helvetica',
                      fontColor: '#006192'
                    }
                  }],
                },
                legend: {
                 
                  display: true,
                  position: 'top',
                  labels: {
                    usePointStyle: true,
                    fontColor: '#006192',
                    fontSize: 18,
                    fontFamily: 'Helvetica',
                  }
                },
                tooltips: {
                  // content: '{pathology}: {number}',
                  backgroundColor: '#1c1c1c',
                  bodyFontSize: 18,
                  titleFontSize: 18,
                  cornerRadius: 5,
                  caretPadding: 10
                },
                title: {
                  display: true,
                  text: "N° di utenti attivi/inattivi",
                  fontColor: '#006192',
                  fontSize: 20,
                  fontFamily: 'Helvetica',
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                }
              }
            });
            } // dopo aver ottenuto tutti i dati creo il bar chart
        
      }
      